module.exports = __webpack_public_path__ + "img/tg.b5aba65b.svg";